import {react, useContext, useState, useEffect, Fragment} from 'react';
import GlobalContext from "../context/GlobalContext.js";
import Modal from 'react-modal';
import postAPI from '../functions/API/postAPI.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'


export default function Nav() {
    const [accessibilityModal, setAccessibilityModal] = useState(false);
    const [reload, setReload] = useState(true);
    const [logoURL, setLogoURL] = useState(localStorage.getItem('logoURL'));
    const [darkModeLogo, setDarkModeLogo] = useState();
    const {theme, updateTheme, themeCSS, settings, setRunWalkthrough} = useContext(GlobalContext)
    const [showWalkthroughButton, setShowWalkThroughButton] = useState(false);

    async function logout(){
        const body = {"":""}
        let destroy = await postAPI('token/destroy', body);
        if (destroy.response.ok) {
            localStorage.clear();
            window.location.href = '/'
        }
    }
    
    function goToProfile(){
        window.location.href = '/profile'
    }

    function Logo() {
        let logo;
        if(theme && theme == 'dark'){
            if(darkModeLogo) logo = darkModeLogo;
        } else {
            if(logoURL) logo = logoURL;
        }
        
        if (logo) {
            return (
                <a href='/' className="normal-case text-xl">
                    <img 
                    src={logo}
                    alt="logo"
                    width="140"
                    className="mx-auto"
                    />
                </a>
            );
        } else {
            return (
                <a href='/' className="normal-case text-xl">{settings.company_name}</a>
            );
        }
    }

    function openInNewWindow(url, name, params){
        window.open(url, name, params);
    }

    function showAdditionalMenuItemsOnHomePage(){
        if (window.location.pathname == "/" || window.location.pathname == "/home") {
            setShowWalkThroughButton(true);
        } else {
            setShowWalkThroughButton(false);
        }
    }

    useEffect(() => {
        if(reload == true){
            showAdditionalMenuItemsOnHomePage();
            setLogoURL(settings.logo_url)
            setDarkModeLogo(settings.dark_mode_logo_url);
            setReload(false)
        }
    }, [reload]);

    return (
        <div>
            <div className={"navbar bg-base-100 " + (themeCSS.divCSS)}>
                <div className="navbar-start">
                    <div id="nav-demo" className="dropdown">
                        <div className="flex">
                            <label title="Menu" tabIndex="0" className="btn btn-ghost btn-circle">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
                            </label>
                            {!!settings.test_system && (
                                <div className="grid content-center hidden sm:block">
                                    <span className="h-6 rounded-md bg-red-100 px-2 py-1 text-sm text-nowrap font-medium text-red-700">
                                        Test System
                                    </span>
                                </div>
                            )}
                        </div>
                    {settings && (
                    <ul tabIndex="0" className={"menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52 " + (themeCSS.divCSS)}>
                        <li><a href="/">Home</a></li>
                        {settings.transactions_enabled === 1  && (
                        <li><a href="/transactions">Transactions</a></li>
                        )}
                        {settings.repairs_enabled === 1  && (
                        <li><a href="/repairs">Repairs</a></li>
                        )}
                        {settings.requests_enabled === 1  && (
                        <li><a href="/requests">Requests</a></li>
                        )}
                        <li><a href="/profile">Profile</a></li>
                        {settings.privacy_policy_url && (
                        <li><a href={settings.privacy_policy_url}>Privacy Policy</a></li>
                        )}
                        {settings.company_website_url && (
                        <li><a href={settings.company_website_url}>Our Website</a></li>
                        )}
                        <li><a href="/appointments">Appointments</a></li>
                        <li><a href="/messages">Messages</a></li>
                    </ul>
                    )}
                    </div>
                </div>
                <div id="logo-demo" className="navbar-center pb-2">
                    <div className='flex-row'>
                        <Logo/>
                        {!!settings.test_system && (
                            <div className="grid content-center sm:hidden mt-1">
                                <span className="h-6 rounded-md bg-red-100 px-2 pt-[1px] text-sm text-center font-medium text-red-700">
                                    Test System
                                </span>
                            </div>
                        )}
                    </div>                 
                </div>
                <div className="navbar-end">
                    <Menu as="div" className="lg:hidden relative text-left">
                        <div>
                        <Menu.Button className={"inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold shadow-sm ring-1 ring-inset ring-gray-300 " + (themeCSS.divCSS)}>
                            Options
                            <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                            </Menu.Button>
                        </div>

                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className={"py-1" + (themeCSS.divCSS)}>
                                {showWalkthroughButton && (
                                    <Menu.Item>
                                    {({ active }) => (
                                        <a
                                        onClick={() => {setRunWalkthrough(true)}}
                                        className={"block px-4 py-2 text-sm " + (themeCSS.menu)}
                                        title="Accessibility Options"
                                        >
                                        Quick Start Guide
                                        </a>
                                    )}
                                    </Menu.Item>
                                )}
                                {settings && settings.chat_enabled && settings.chat_provider == 'koopid' && settings.koopid_mobile_app_url ? (
                                    <Menu.Item>
                                    {({ active }) => (
                                        <a
                                        title="Live Chat"  
                                        target="popout" 
                                        onClick={()=>{openInNewWindow(settings.koopid_mobile_app_url, "Live Chat", "width=400,height=600")}}
                                        className={"block px-4 py-2 text-sm " + (themeCSS.menu)}
                                        >
                                        Live Chat
                                        </a>
                                    )}
                                    </Menu.Item>
                                ):(
                                    <></>
                                )}

                                <Menu.Item>
                                {({ active }) => (
                                    <a
                                    onClick={() => {setAccessibilityModal(true)}}
                                    className={"block px-4 py-2 text-sm " + (themeCSS.menu)}
                                    title="Accessibility Options"
                                    >
                                    Accessibility
                                    </a>
                                )}
                                </Menu.Item>
                                <Menu.Item>
                                {({ active }) => (
                                    <a
                                    onClick={() => {goToProfile()}}
                                    className={"block px-4 py-2 text-sm " + (themeCSS.menu)}
                                    title="Profile"
                                    >
                                    Profile
                                    </a>
                                )}
                                </Menu.Item>
                                <Menu.Item>
                                {({ active }) => (
                                    <a
                                    onClick={() => {logout()}}
                                    className={"block px-4 py-2 text-sm " + (themeCSS.menu)}
                                    title="Logout"
                                    >
                                    Logout
                                    </a>
                                )}
                                </Menu.Item>
                                <form method="POST" action="#">
                                </form>
                            </div>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                    <div className='hidden lg:block'>
                        {showWalkthroughButton && (
                            <button title="Run walkthrough" className="btn btn-ghost btn-circle" onClick={() => {setRunWalkthrough(true)}}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.9939 2.00606 17.5203 2 12V11.8C2.10993 6.30452 6.63459 1.92794 12.1307 2.00087C17.6268 2.07379 22.0337 6.56887 21.9978 12.0653C21.9619 17.5618 17.4966 21.9989 12 22ZM11.984 20H12C16.4167 19.9956 19.9942 16.4127 19.992 11.996C19.9898 7.57928 16.4087 3.99999 11.992 3.99999C7.57528 3.99999 3.99421 7.57928 3.992 11.996C3.98979 16.4127 7.56729 19.9956 11.984 20ZM13 18H11V16H13V18ZM13 15H11C10.9684 13.6977 11.6461 12.4808 12.77 11.822C13.43 11.316 14 10.88 14 9.99999C14 8.89542 13.1046 7.99999 12 7.99999C10.8954 7.99999 10 8.89542 10 9.99999H8V9.90999C8.01608 8.48093 8.79333 7.16899 10.039 6.46839C11.2846 5.76778 12.8094 5.78493 14.039 6.51339C15.2685 7.24184 16.0161 8.57093 16 9.99999C15.9284 11.079 15.3497 12.0602 14.44 12.645C13.6177 13.1612 13.0847 14.0328 13 15Z" fill={(themeCSS.iconHex)}></path>
                                </svg>
                            </button>
                        )}

                        {settings && settings.chat_enabled && settings.chat_provider == 'koopid' && settings.koopid_mobile_app_url ? (
                            // <KoopidChat url={settings.koopid_region} email={settings.koopid_email} tag={settings.koopid_tag}/>
                            <a title="Live Chat"  target="popout" onClick={()=>{openInNewWindow(settings.koopid_mobile_app_url, "Live Chat", "width=400,height=600")}} className="btn btn-ghost btn-circle">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 2C17.1046 2 18 2.89543 18 4L4 4L4 15.1765C2.89543 15.1765 2 14.281 2 13.1765V4C2 2.89543 2.89543 2 4 2H16Z" fill={(themeCSS.iconHex)}></path>
                                    <path d="M14 22L11.3333 19.1765H8C6.89543 19.1765 6 18.281 6 17.1765V8C6 6.89543 6.89543 6 8 6H20C21.1046 6 22 6.89543 22 8V17.1765C22 18.281 21.1046 19.1765 20 19.1765H16.6667L14 22ZM15.8046 17.1765L20 17.1765V8L8 8V17.1765H12.1954L14 19.0872L15.8046 17.1765Z" fill={(themeCSS.iconHex)}></path>
                                </svg>
                            </a>
                        ):(
                            <></>
                        )}

                        <button title="Accessibility Options" className="btn btn-ghost btn-circle" onClick={() => {setAccessibilityModal(true)}}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.8199 22H10.1799C9.71003 22 9.30347 21.673 9.20292 21.214L8.79592 19.33C8.25297 19.0921 7.73814 18.7946 7.26092 18.443L5.42392 19.028C4.97592 19.1709 4.48891 18.9823 4.25392 18.575L2.42992 15.424C2.19751 15.0165 2.27758 14.5025 2.62292 14.185L4.04792 12.885C3.98312 12.2961 3.98312 11.7019 4.04792 11.113L2.62292 9.816C2.27707 9.49837 2.19697 8.98372 2.42992 8.576L4.24992 5.423C4.48491 5.0157 4.97192 4.82714 5.41992 4.97L7.25692 5.555C7.50098 5.37416 7.75505 5.20722 8.01792 5.055C8.27026 4.91269 8.52995 4.78385 8.79592 4.669L9.20392 2.787C9.30399 2.32797 9.71011 2.00049 10.1799 2H13.8199C14.2897 2.00049 14.6958 2.32797 14.7959 2.787L15.2079 4.67C15.4887 4.79352 15.7622 4.93308 16.0269 5.088C16.2739 5.23081 16.5126 5.38739 16.7419 5.557L18.5799 4.972C19.0276 4.82967 19.514 5.01816 19.7489 5.425L21.5689 8.578C21.8013 8.98548 21.7213 9.49951 21.3759 9.817L19.9509 11.117C20.0157 11.7059 20.0157 12.3001 19.9509 12.889L21.3759 14.189C21.7213 14.5065 21.8013 15.0205 21.5689 15.428L19.7489 18.581C19.514 18.9878 19.0276 19.1763 18.5799 19.034L16.7419 18.449C16.5093 18.6203 16.2677 18.7789 16.0179 18.924C15.7557 19.0759 15.4853 19.2131 15.2079 19.335L14.7959 21.214C14.6954 21.6726 14.2894 21.9996 13.8199 22ZM7.61992 16.229L8.43992 16.829C8.62477 16.9652 8.81743 17.0904 9.01692 17.204C9.20462 17.3127 9.39788 17.4115 9.59592 17.5L10.5289 17.909L10.9859 20H13.0159L13.4729 17.908L14.4059 17.499C14.8132 17.3194 15.1998 17.0961 15.5589 16.833L16.3799 16.233L18.4209 16.883L19.4359 15.125L17.8529 13.682L17.9649 12.67C18.0141 12.2274 18.0141 11.7806 17.9649 11.338L17.8529 10.326L19.4369 8.88L18.4209 7.121L16.3799 7.771L15.5589 7.171C15.1997 6.90671 14.8132 6.68175 14.4059 6.5L13.4729 6.091L13.0159 4H10.9859L10.5269 6.092L9.59592 6.5C9.39772 6.58704 9.20444 6.68486 9.01692 6.793C8.81866 6.90633 8.62701 7.03086 8.44292 7.166L7.62192 7.766L5.58192 7.116L4.56492 8.88L6.14792 10.321L6.03592 11.334C5.98672 11.7766 5.98672 12.2234 6.03592 12.666L6.14792 13.678L4.56492 15.121L5.57992 16.879L7.61992 16.229ZM11.9959 16C9.78678 16 7.99592 14.2091 7.99592 12C7.99592 9.79086 9.78678 8 11.9959 8C14.2051 8 15.9959 9.79086 15.9959 12C15.9932 14.208 14.2039 15.9972 11.9959 16ZM11.9959 10C10.9033 10.0011 10.0138 10.8788 9.99815 11.9713C9.98249 13.0638 10.8465 13.9667 11.9386 13.9991C13.0307 14.0315 13.9468 13.1815 13.9959 12.09V12.49V12C13.9959 10.8954 13.1005 10 11.9959 10Z" fill={(themeCSS.iconHex)}></path>
                            </svg>
                        </button>

                        <button title="Manage Profile" id="profile-demo" className="btn btn-ghost btn-circle" onClick={() => {goToProfile()}}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0001 22C10.4882 22.0043 8.99532 21.6622 7.6361 21C7.13865 20.758 6.66203 20.4754 6.2111 20.155L6.0741 20.055C4.83392 19.1396 3.81997 17.9522 3.1101 16.584C2.37584 15.1679 1.99501 13.5952 2.00005 12C2.00005 6.47715 6.47725 2 12.0001 2C17.5229 2 22.0001 6.47715 22.0001 12C22.0051 13.5944 21.6247 15.1664 20.8911 16.582C20.1822 17.9494 19.1697 19.1364 17.9311 20.052C17.4639 20.394 16.968 20.6951 16.4491 20.952L16.3691 20.992C15.009 21.6577 13.5144 22.0026 12.0001 22ZM12.0001 17C10.5016 16.9971 9.12776 17.834 8.4431 19.167C10.6845 20.2772 13.3157 20.2772 15.5571 19.167V19.162C14.8716 17.8305 13.4977 16.9954 12.0001 17ZM12.0001 15C14.1662 15.0028 16.1635 16.1701 17.2291 18.056L17.2441 18.043L17.2581 18.031L17.2411 18.046L17.2311 18.054C19.7601 15.8691 20.6644 12.3423 19.4987 9.21011C18.3331 6.07788 15.3432 4.00032 12.0011 4.00032C8.65901 4.00032 5.66909 6.07788 4.50345 9.21011C3.33781 12.3423 4.2421 15.8691 6.7711 18.054C7.83736 16.169 9.83446 15.0026 12.0001 15ZM12.0001 14C9.79096 14 8.0001 12.2091 8.0001 10C8.0001 7.79086 9.79096 6 12.0001 6C14.2092 6 16.0001 7.79086 16.0001 10C16.0001 11.0609 15.5787 12.0783 14.8285 12.8284C14.0784 13.5786 13.061 14 12.0001 14ZM12.0001 8C10.8955 8 10.0001 8.89543 10.0001 10C10.0001 11.1046 10.8955 12 12.0001 12C13.1047 12 14.0001 11.1046 14.0001 10C14.0001 8.89543 13.1047 8 12.0001 8Z" fill={(themeCSS.iconHex)}></path>
                            </svg>
                        </button>

                        <button title="Logout" className="btn btn-ghost btn-circle" onClick={() => {logout()}}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 21H10C8.89543 21 8 20.1046 8 19V15H10V19H19V5H10V9H8V5C8 3.89543 8.89543 3 10 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM12 16V13H3V11H12V8L17 12L12 16Z" fill={(themeCSS.iconHex)}></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                isOpen={accessibilityModal}
                //onAfterOpen={afterOpenModal}
                onRequestClose={() => {setAccessibilityModal(false)}}
                className="my-20 mx-2 pb-12 md:mx-40 overflow-y-auto overflow-x-hidden fixed right-0 left-0 z-50 justify-center items-center h-modal h-full"
                contentLabel="Accessibility Options">
                    <div>

                        <div className={"rounded-2xl border overflow-auto p-10 " + (themeCSS.divCSS)}>
                            <div className="flex flex-col items-center space-y-2">
                                <h1 className={"font-bold text-2xl w-4/6 text-center " + (themeCSS.divCSS)}>Accessibility Settings</h1>
                                <p className={"text-sm text-center w-5/6 " + (themeCSS.divCSS)}>You can switch between different themes to get a better experience using our portal.</p>
                                <div className="grid grid-cols-1 md:grid-cols-2 w-full md:space-x-4 space-y-2 md:space-y-0">
                                    <div>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 w-full md:space-x-4 space-y-2 md:space-y-0">
                                    <div>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-1">
                                <button className="btn btn-natural capitalize rounded-md font-semibold mb-4 bg-white text-slate-800 hover:bg-white" onClick={() => {updateTheme('light'); setAccessibilityModal(false)}}>Light Mode</button>
                                <button className="btn btn-natural capitalize text-white rounded-md font-semibold mb-4 bg-slate-800 hover:bg-slate-800" onClick={() => {updateTheme('dark'); setAccessibilityModal(false)}}>Dark Mode</button>
                                <button className="btn btn-natural capitalize border-0 rounded-md font-semibold mb-4 bg-yellow-300 text-red-500 hover:bg-yellow-300" onClick={() => {updateTheme('highContrast'); setAccessibilityModal(false)}}>High Contrast Mode</button>
                            </div>
                            
                        </div>
                    </div>
            </Modal>
            <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
        </div>
    )
}